import styled from '@emotion/styled';
import React from 'react';
import { Reading, Sample } from '../types';
import { Field, FieldName, FieldValue } from './shared/Field';
import { ReadingCode } from '../constants/readingCode';
import { useOutliersUtil } from 'hooks/useOutliersUtil';

const CardListItem = styled.div<{ error?: boolean; }>`
  & > div {
    ${({ error }) => (error ? 'border: 1px solid #ff5722; background: #ffa270;' : '')}
    padding: 0 10px;
    margin: 0 -10px;
  }
`;

const Checkbox = styled.input`
  margin: 0 10px 0 0 !important;
`;
interface Props {
  reading?: Reading;
  locked?: boolean;
  onLock?: (locked: boolean) => void;
  sample?: Sample;
}

export const ReadingItem = ({
  reading,
  locked,
  onLock,
  sample
}: Props) => {
  const { showErrorForOutlier } = useOutliersUtil();
  return (
    <CardListItem
        error={showErrorForOutlier(reading, sample)}
      >
        <Field>
          {onLock && (
            <Checkbox
              type="checkbox"
              checked={locked ?? false}
              onChange={(e) => onLock(e.target.checked)}
            />
          )}

          <FieldName>
            <span>{reading?.code} </span>
            <b>{reading?.sourceName} </b>
          </FieldName>
          <FieldValue>
            <strong>{reading?.result === ReadingCode.EMPTY_STRING && reading?.value === 0 ? null : reading?.value} </strong>
            {reading?.outliers?.length ? (
              <>
                {reading?.outliers.some((outlier) => Math.round(outlier.value) > 0) ? (
                  <>
                    (
                    {reading?.outliers.map((outlier, index) => {
                      return (
                        <React.Fragment key={index}>
                          {Math.round(outlier.value)}
                        </React.Fragment>
                      );
                    })}
                    )
                  </>
                ) : null}
              </>
            ) : null}
          </FieldValue>
        </Field>
      </CardListItem>
  );
};
